import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {display} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../hooks/use_responsive_link_target";

interface IProps {
    href: string;
    label: string;
    linkText: string;
    linkPosition?: ILinkPostion;
}

type ILinkPostion = "left" | "right";

export const LinkWithLabel = (props: IProps) => {
    const target = useResponsiveLinkTarget();
    const linkPosition = props.linkPosition || "right";

    return (
        <div css={linkWithLabel}>
            {linkPosition === "right" ? (
                <>
                    <Label variant="info_txt_1">{props.label}</Label>
                    <StyledLink href={props.href} size="small" target={target}>
                        {props.linkText}
                    </StyledLink>
                </>
            ) : (
                <>
                    <StyledLink href={props.href} size="small" target={target}>
                        {props.linkText}
                    </StyledLink>
                    <Label variant="info_txt_1">{props.label}</Label>
                </>
            )}
        </div>
    );
};

const linkWithLabel = css`
    min-height: 1.6rem;
    line-height: 1.2rem;
`;

const Label = styled(Text)`
    margin-right: 0.2rem;
    color: ${(props) => props.theme.colors.gray["700"]};
    ${display("inline")};
`;

const StyledLink = styled(Link)`
    color: ${(props) => props.theme.colors.gray["700"]};
    text-decoration: underline;
    line-height: 0;
    ${display("inline")};
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {display} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../hooks/use_responsive_link_target";

interface IProps {
    href: string;
    label: string;
    linkText: string;
    linkPosition?: ILinkPostion;
}

type ILinkPostion = "left" | "right";

export const LinkWithLabel = (props: IProps) => {
    const target = useResponsiveLinkTarget();
    const linkPosition = props.linkPosition || "right";

    return (
        <div css={linkWithLabel}>
            {linkPosition === "right" ? (
                <>
                    <Label variant="info_txt_1">{props.label}</Label>
                    <StyledLink href={props.href} size="small" target={target}>
                        {props.linkText}
                    </StyledLink>
                </>
            ) : (
                <>
                    <StyledLink href={props.href} size="small" target={target}>
                        {props.linkText}
                    </StyledLink>
                    <Label variant="info_txt_1">{props.label}</Label>
                </>
            )}
        </div>
    );
};

const linkWithLabel = css`
    min-height: 1.6rem;
    line-height: 1.2rem;
`;

const Label = styled(Text)`
    margin-right: 0.2rem;
    color: ${(props) => props.theme.colors.gray["700"]};
    ${display("inline")};
`;

const StyledLink = styled(Link)`
    color: ${(props) => props.theme.colors.gray["700"]};
    text-decoration: underline;
    line-height: 0;
    ${display("inline")};
`;
